import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import ButtonSecondary from "shared/Button/ButtonSecondary";

const GoBackBtn = ({ className = "", navigateTo, variant }: any) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(navigateTo || -1);
  };

  return (
    <ButtonSecondary
      onClick={handleGoBack}
      className={`flex gap-2 text-sm font-inter w-fit ${className}`}
      variant={variant || "info"}
    >
      <ArrowLeft size={16} />
      Go Back
    </ButtonSecondary>
  );
};

export default GoBackBtn;
